import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import { brainTokens } from "../design/brainTheme";

const c = brainTokens.color;

/** Flat segmented control per the design (Site Visits filter/sort, list filter):
 *  #f2f4f6 track, white active chip with a soft shadow. */
export function Segmented<T extends string>({
  value,
  onChange,
  options,
  sx,
}: {
  value: T;
  onChange: (v: T) => void;
  options: { key: T; label: string; tone?: "danger" }[];
  sx?: SxProps<Theme>;
}) {
  return (
    <Box sx={{ display: "inline-flex", background: c.borderLight3, borderRadius: "8px", padding: "3px", gap: "2px", flexWrap: "wrap", ...sx }}>
      {options.map((o) => {
        const active = value === o.key;
        const danger = o.tone === "danger";
        return (
          <Box
            key={o.key}
            component="button"
            type="button"
            aria-pressed={active}
            onClick={() => onChange(o.key)}
            sx={{
              border: "none",
              fontFamily: brainTokens.font.sans,
              padding: "6px 14px",
              borderRadius: "6px",
              fontSize: 13,
              fontWeight: 500,
              cursor: "pointer",
              whiteSpace: "nowrap",
              color: danger ? c.dangerText : active ? c.ink : "#7a828a",
              background: active ? (danger ? c.dangerBg : "#fff") : "transparent",
              boxShadow: active ? "0 1px 2px rgba(0,0,0,.06)" : "none",
              "&:hover": { color: danger ? c.dangerText : c.ink },
            }}
          >
            {o.label}
          </Box>
        );
      })}
    </Box>
  );
}
